<template>
    <div class="gradient uk-padding">   
        <slot></slot>
        <div class="uk-text-center">
            <div v-html="title"></div>
            <button v-if="showNext" 
                    @click="EndAction(frameNum+1)" 
                    class="uk-button uk-button-primary navigate-frame-btn">Back To Modules<span uk-icon="icon: chevron-right; ratio: 2"></span></button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: "Thank You"
        },
        frameNum:{
            type: Number,
            default: 0
        },
        nextFrame:{
            type: Function
        },
        previousFrame: {
            type: Function
        },
        showNext: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        previousFrameQuestion(){
            this.previousFrame(this.frameNum-1)
        },
        nextFrameQuestion(){
            this.nextFrame(this.frameNum+1)
        },
        EndAction(){
            this.nextFrame('dashboard')
        }
    }
}
</script>

<style>
    .gradient {
            background: white;
    }
</style>


